module.exports = __webpack_public_path__ + "static/media/metatavu.e5e7d31e.svg";